
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import Weather from './Weather';

export default function App() {
  return (
    <div className="App">
      <div className='container'>
 <h1>Weather App </h1>  
 <Weather defaultCity = "Dublin"/> 
   <footer> 
    This Project was coded by <a href="https://main--legendary-starship-78eb70.netlify.app/" target="blank"> Rachael Dillon </a> and is
   <a href="https://github.com/Raedillon333/my-react-weather-app" target="blank" rel="noopener referrer"> Open Source</a>
   </footer>
   </div>
   </div>
  );
}


